//esta página é uma listagem de produtos cadastrados no sistema, com a possibilidade de cadastrar novos produtos, editar e excluir produtos existentes.
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import {CircularProgress} from '@mui/material';
import MenuAssociados from '../components/MenuAssociados';

function Produtos() {

    const [produtos, setProdutos] = useState([]);
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState(sessionStorage.selectStatusRegistro !== undefined ? sessionStorage.selectStatusRegistro : '99');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);
    const navigate = useNavigate();

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
    

    //valida se o usuário está logado, caso não esteja, redireciona para a página de login
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    //salvar log de navegação
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Navegação",
        logModulo: "Página de Produtos",
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data[0].mensagem);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
        });
    }, []);

    //obtem a lista de produtos cadastrados no sistema
    useEffect(() => {
        var tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        setIsLoadingMOD(true);
        axios
        .get(process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=obterProdutos', {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(response => {
            if (response.data) {
                if (response.data.message) {
                    setProdutos([]);
                    setIsLoadingMOD(false);
                    return;
                } else {
                    setProdutos(response.data);
                    setIsLoadingMOD(false);
                }
            } else {
                setProdutos([]);
                setIsLoadingMOD(false);
            }
        })
        .catch(error => {
            let ret = error.message;
            setIsLoadingMOD(false);
            if (ret.includes("401")) {
                console.log("token inválido!")
            }
            else if (ret.includes("403")) {
                //window.location.reload();
            }
        });
    }, []);

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = useState(config);
        const sortedItems = useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = key => {
            let direction = 'ascending';
            if (sortConfig && 
                sortConfig.key === key && 
                sortConfig.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };
    const { items, requestSort, sortConfig } = useSortableData(produtos);

    const getClassNamesFor = name => {
        if (!sortConfig) {
        return;
        }
        return sortConfig.key === name ? sortConfig.direction : undefined
    }

    function handleNovoProduto() {
        //setModalOpen(false);
    }
 
    function handleSelectStatusChange(event) {
        const selectedValue = event.target.value;
        setSelectStatus(selectedValue);
        sessionStorage.selectStatusRegistro = selectedValue;
    }

    function handleEditProduto(produto) {
        //console.log('Produto selecionado para edição:', produto); return;
        sessionStorage.setItem('produtoClicked', produto.IdProduto);
        navigate(`/Produto`, { state: { produtoInfo: produto } });
    }

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        // 1. Verifica se existe um ID guardado na memória do navegador
        const itemClicadoId = sessionStorage.getItem('produtoClicked');
    
        if (itemClicadoId) {
          const elementoLinha = document.getElementById(`produto-${itemClicadoId}`);
          
          if (elementoLinha) {
            // Rola até a linha clicada de forma suave
            setTimeout(() => {
              elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
              // Destaque visual temporário opcional (ex: piscar a linha)
              elementoLinha.style.backgroundColor = '#fff9c4'; 
              setTimeout(() => elementoLinha.style.backgroundColor = '', 3000);
            }, 100); // Um pequeno delay garante que o HTML já renderizou
    
            // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
            sessionStorage.removeItem('produtoClicked');
          }
        }
      }, [items]);

    return (
        <div>
            <main style={{paddingBottom: '80px'}}>
                <div>
                    <div>
                        <MenuAssociados />
                    </div>
                    <div className="headerMain">
                        <label className='labelTitulo' >PRODUTOS</label>
                        <label className='labelSubTitulo'>Cadastro de produtos disponíveis para venda</label>
                    </div>

                    <div className="containerBarraPesquisa">
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        // <Link to="/Produto">
                            <button className="buttonModalPadrao" onClick={() => navigate('/Produto')}>
                                NOVO PRODUTO
                            </button>
                        // </Link> ) 
                        ): ('')}

                        <input className="inputBarraPesquisa"
                        placeholder="PESQUISAR"
                        type="text"
                        id="inputPesquisa"
                        name="inputPesquisa"
                        onChange={event => {
                            setSearchTerm(event.target.value)
                        }}
                        />

                        <select className="selectStatusPesquisa"
                        name="SelectStatusRegistro"
                        selected={sessionStorage.selectStatusRegistro !== undefined ? sessionStorage.selectStatusRegistro : '99'}
                        onChange={event => {
                            handleSelectStatusChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusRegistro === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusRegistro === '1'} >ATIVOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusRegistro === '0'} >INATIVOS</option>
                        </select>
                    </div>

                    <div className="tabelaPadrao">
                        {windowWidth < 769 ? (
                            isLoadingMOD ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                            <div className="tabelaDados">
                                {items && items.filter((produto) => {
                                    if (searchTerm === '') {
                                        return produto;
                                    } else if (
                                        produto.proDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        produto.proTipo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        produto.proModelo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        produto.proCor.toLowerCase().includes(searchTerm.toLowerCase())
                                    ) {
                                        return produto;
                                    }
                                    return null;
                                })
                                .filter((produto) => {
                                    if (selectStatus === '99') {
                                        return produto;
                                    } else if (selectStatus === '1' && produto.proStatus === 1) {
                                        return produto;
                                    } else if (selectStatus === '0' && produto.proStatus === 0) {
                                        return produto;
                                    }
                                    return null;
                                })
                                .map(produto => (
                                    <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '15px' }}>
                                        <div key={produto.IdProduto} id={`produto-${produto.IdProduto}`} onClick={() => handleEditProduto(produto)} style={{ cursor: 'pointer'}}>
                                            <p style={{ color: '#000' }}><b>CÓD: {produto.IdProduto}</b></p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>DESCRIÇÃO:</b> {produto.proDescricao}</p>

                                            <p style={{ color: '#000', marginTop: '10px' }}><b>MODELO:</b> {produto.proModelo}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>TIPO:</b> {produto.proTipo}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>COR:</b> {produto.proCor}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>TAMANHO:</b> {produto.proTamanho}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>ACEITA PEDIDOS:</b> {produto.proAceitaPedido === 1 ? 'SIM' : 'NÃO'}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>DEPENDE DE ESTOQUE:</b> {produto.proDependeEstoque === 1 ? 'SIM' : 'NÃO'}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>STATUS:</b> {produto.proStatus === 1 ? 'ATIVO' : 'INATIVO'}</p>
                                            <p style={{ color: '#000', marginTop: '10px' }}><b>VALOR DE VENDA:</b> {produto.proValorVenda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        </div>
                                        <div className="pt3 tdTextAlignCenter" style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                                            <button className="buttonModalPadrao" onClick={() => navigate(`/ProdutoFotos/${produto.IdProduto}`)}>
                                                FOTOS
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            isLoadingMOD ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                        <table className="tabelaDados">
                            <thead>
                                <tr style={{ cursor: 'pointer'}}>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('IdProduto')} className={getClassNamesFor('IdProduto')}>
                                    CÓD
                                    </th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('proDescricao')} className={getClassNamesFor('proDescricao')}>
                                    DESCRIÇÃO
                                    </th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('proModelo')} className={getClassNamesFor('proModelo')}>
                                    MODELO
                                    </th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('proTipo')} className={getClassNamesFor('proTipo')}>
                                    TIPO
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('proCor')} className={getClassNamesFor('proCor')}>
                                    COR
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('proTamanho')} className={getClassNamesFor('proTamanho')}>
                                    TAMANHO
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('proAceitaPedido')} className={getClassNamesFor('proAceitaPedido')}>
                                    ACEITA PEDIDOS
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('proDependeEstoque')} className={getClassNamesFor('proDependeEstoque')}>
                                    DEPENDE DE ESTOQUE
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('proStatus')} className={getClassNamesFor('proStatus')}>
                                    STATUS
                                    </th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('proValorVenda')} className={getClassNamesFor('proValorVenda')}>
                                    VALOR DE VENDA
                                    </th>
                                    <th style={{ textAlign: "center" }} >
                                    FOTOS DO PRODUTO
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {items && items.filter((produto) => {
                                    if (searchTerm === '') {
                                        return produto;
                                    } else if (
                                        produto.proDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        produto.proTipo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        produto.proModelo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        produto.proCor.toLowerCase().includes(searchTerm.toLowerCase())
                                    ) {
                                        return produto;
                                    }
                                    return null;
                                })
                                .filter((produto) => {
                                    if (selectStatus === '99') {
                                        return produto;
                                    } else if (selectStatus === '1' && produto.proStatus === 1) {
                                        return produto;
                                    } else if (selectStatus === '0' && produto.proStatus === 0) {
                                        return produto;
                                    }
                                    return null;
                                })
                                .map(produto => (
                                    <tr key={produto.IdProduto} id={`produto-${produto.IdProduto}`} onClick={() => handleEditProduto(produto)} style={{ cursor: 'pointer'}}>
                                        <td style={{ textAlign: "center" }}>{produto.IdProduto}</td>
                                        <td style={{ textAlign: "left" }}>{produto.proDescricao}</td>
                                        <td style={{ textAlign: "left" }}>{produto.proModelo}</td>
                                        <td style={{ textAlign: "left" }}>{produto.proTipo}</td>
                                        <td style={{ textAlign: "center" }}>{produto.proCor}</td>
                                        <td style={{ textAlign: "center" }}>{produto.proTamanho}</td>
                                        <td style={{ textAlign: "center" }}>{produto.proAceitaPedido === 1 ? 'SIM' : 'NÃO'}</td>
                                        <td style={{ textAlign: "center" }}>{produto.proDependeEstoque === 1 ? 'SIM' : 'NÃO'}</td>
                                        <td style={{ textAlign: "center" }}>{produto.proStatus === 1 ? 'ATIVO' : 'INATIVO'}</td>
                                        <td style={{ textAlign: "center" }}>{produto.proValorVenda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <Link to={`/ProdutoFotos/${produto.IdProduto}`}>
                                                <button className="buttonModalPadrao">
                                                    FOTOS
                                                </button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Produtos;